import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-view-mail-notification-dialog',
  templateUrl: './view-mail-notification-dialog.component.html',
  styleUrls: ['./view-mail-notification-dialog.component.scss']
})
export class ViewMailNotificationDialogComponent implements OnInit {
  public viewMailData: any;
  public sanitizedHtml: SafeHtml;
  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: any,private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.viewMailData = this.dialogData;
    var body = '';

    if (this.viewMailData && this.viewMailData.emailBody) {
      body = this.viewMailData.emailBody;
    }

    this.sanitizedHtml = this.sanitizer.bypassSecurityTrustHtml(body);
}

}
